import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import "./PublishButton.css";
import PublishPopup from "./PublishPopup";
import UnpublishConfirmationPopup from "./UnpublishConfirmationPopup";
import DeletePublication from "../../../../utils/database/DeletePublication"
import UserDetails from "../../../../utils/auth/UserDetails";
import GetChatStatus from "../../../../utils/database/GetChatStatus";

const PublishButton = ({ chatObject }) => {
    const [buttonState, setButtonState] = useState("private");
    const [showPopup, setShowPopup] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const userDetails = UserDetails();
    const userId = userDetails?.userId;

    useEffect(() => {
        const fetchChatStatus = async () => {
            if (chatObject?.chatId && userId) {
                const status = await GetChatStatus(chatObject.chatId, userId);
                if (status) {
                    setButtonState(status === "public" ? "published" : "private");
                }
            }
        };
        fetchChatStatus();
    }, [chatObject, userId]);

    const handleClick = () => {
        if (buttonState === "publish") {
            setShowPopup(true);
        } else if (buttonState === "unpublish") {
            setShowConfirmation(true);
        }
    };

    const handleMouseEnter = () => {
        if (buttonState === "private") {
            setButtonState("publish");
        } else if (buttonState === "published") {
            setButtonState("unpublish");
        }
    };

    const handleMouseLeave = () => {
        if (buttonState === "unpublish") {
            setButtonState("published");
        } else {
            setButtonState("private");
        }
    };

    const handlePublish = () => {
        setButtonState("published");
        setShowPopup(false);
    };

    const handleUnpublish = async () => {
        try {
            const result = await DeletePublication(chatObject.chatId, userId);
            if (result) {
                setButtonState("private");
            }
        } catch (error) {
            // console.error("Failed to delete publication:", error);
        }
        setShowConfirmation(false);
    };

    const getButtonProps = () => {
        switch (buttonState) {
            case "private":
                return { label: "Private", icon: "pi pi-lock", className: "custom-button private-button" };
            case "publish":
                return { label: "Publish", icon: "pi pi-upload", className: "custom-button publish-button" };
            case "published":
                return { label: "Published", icon: "pi pi-check", className: "custom-button published-button" };
            case "unpublish":
                return { label: "Unpublish", icon: "pi pi-times", className: "custom-button unpublish-button" };
            default:
                return { label: "Private", icon: "pi pi-lock", className: "custom-button private-button" };
        }
    };

    const buttonProps = getButtonProps();

    return (
        <>
            <Button
                label={buttonProps.label}
                icon={buttonProps.icon}
                onClick={handleClick}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                className={buttonProps.className}
            />
            {showPopup && (
                <PublishPopup
                    open={showPopup}
                    onPublish={handlePublish}
                    onClose={() => setShowPopup(false)}
                    chatObject={chatObject}
                />
            )}
            <UnpublishConfirmationPopup
                open={showConfirmation}
                onConfirm={handleUnpublish}
                onCancel={() => setShowConfirmation(false)}
                chatName={chatObject?.chatName}
            />
        </>
    );
};

export default PublishButton;
